import API from '..';
const ENTITY = 'companies';

export const filterCompanies = ({
    countryName,
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    planName,
    searchText = '',
    sortBy = null,
    status = 'active',
} = {}) =>
    API.get(`/api/v1/${ENTITY}/filter/`, {
        params: {
            order_by: orderBy,
            page: page,
            per_page: perPage,
            ...(searchText ? { search: searchText } : {}),
            ...(planName ? { plan_name: planName } : {}),
            ...(countryName ? { country_name: countryName } : {}),
            sort: sortBy,
            status_flag: status,
        },
    });

/**Companies home */

export const exportFile = ({ countryName, planName, searchText = '' } = {}) =>
    API.get(`/api/v1/${ENTITY}/download/`, {
        params: {
            ...(searchText ? { search: searchText } : {}),
            ...(planName ? { plan_name: planName } : {}),
            ...(countryName ? { country_name: countryName } : {}),
        },
    });

export const getCompanies = () => API.get(`/api/v1/${ENTITY}/catalog/`);

export const getCountries = () => API.get(`/api/v1/${ENTITY}/origins/`);

/** Company detail */

export const getCompanyDetail = (id) =>
    API.get(`/api/v1/${ENTITY}/${id}/detail/`);

export const updateCompanyOwner = (data, id) =>
    API.put(`/api/v1/${ENTITY}/owner/${id}/`, { ...data });

export const getAgents = (id) => API.get(`/api/v1/${ENTITY}/${id}/agents/`);

/** Company users */

export const getUsers = (id, page = 1, orderBy = '', sortBy = '', str = '') =>
    API.get(`/api/v1/${ENTITY}/${id}/users/?search${str ? '=' + str : ''}`, {
        params: { order_by: orderBy, page, sort: sortBy },
    });

export const getUsersCSV = (id, orderBy = '', sortBy = '', str = '') =>
    API.get(
        `/api/v1/${ENTITY}/${id}/users/download/?search${str ? '=' + str : ''}${
            orderBy !== '' ? `&order_by=${orderBy}` : ''
        }${sortBy !== '' ? `&sort=${sortBy}` : ''}`,
    );

export const getUserDetail = (companyId, userId) =>
    API.get(`/api/v1/${ENTITY}/${companyId}/users/${userId}/detail/`);

export const updateUser = (companyId, userId, data) =>
    API.put(`/api/v1/${ENTITY}/${companyId}/users/${userId}/detail/`, {
        ...data,
    });

export const deleteUser = (companyId, userId) =>
    API.delete(`/api/v1/${ENTITY}/${companyId}/users/${userId}/detail/`);

export const getRolesNoPaging = (id) =>
    API.get(`/api/v1/${ENTITY}/${id}/roles-nopage/`);

export const getProjectsCounters = (
    companyId,
    initialDate,
    finalDate,
    agentId = null,
) =>
    API.get(`/api/v1/${ENTITY}/${companyId}/projects-totals/`, {
        params: {
            agent_id: agentId,
            final_date: finalDate,
            initial_date: initialDate,
        },
    });
export const getProposalsTotals = (
    companyId,
    initialDate,
    finalDate,
    agentId = null,
) =>
    API.get(`/api/v1/${ENTITY}/${companyId}/proposals-totals/`, {
        params: {
            agent_id: agentId,
            final_date: finalDate,
            initial_date: initialDate,
        },
    });
